import { datadogRum } from '@datadog/browser-rum';
import { Environment } from './Environment';

export const initializeDatadog = () => {
    datadogRum.init({
        applicationId: '04904eb8-dae8-4657-bfee-85e934d3d7cd',
        clientToken: 'pub281ffad34174356a0de83fbda4930d4a',
        site: 'datadoghq.com',
        service: 'cloverdotcom',
        env: Environment.current.appEnvironmentName,
        sampleRate: 100,
        trackInteractions: true,
    });
};
